/* CHECKOUT: los botones de la sección de oferta llevan a este enlace. */
export const CHECKOUT_URL = "https://corporate-training-ready-360.impultienda.ar/checkout";

export const product = {
  name: "New Manager Essentials",
  brand: "Corporate Training Ready 360",
  price: "47",
  currency: "USD",
  mockup: "https://cdn.magicpatterns.com/uploads/nGRLeUdLu6LYjHGSgjpMFt/Kit_premium_de_capacitacion_para_nuevos_gerentes.png",
};

export const stats = [
  { value: "10", label: "Planned workshops" },
  { value: "5", label: "Bonus resources" },
  { value: "60 MIN", label: "Core sessions" },
  { value: "40", label: "Page playbook" },
];

export const bonuses = [
  {
    title: "30 Ready-to-Run Icebreakers & Energizers",
    text: "Open any session or lift the energy mid-workshop without inventing an activity on the spot.",
    image: "https://cdn.magicpatterns.com/uploads/1aW3W1Hp1uF6WBbavRRpe1/manager_1.webp",
  },
  {
    title: "The 12-Month Manager Training Calendar",
    text: "Lay out your workshops across the year so manager development runs on a clear schedule.",
    image: "https://cdn.magicpatterns.com/uploads/6pd1TbXwZ4Ae4WsyEZfW91/manager_2.webp",
  },
  {
    title: "The Training Needs Survey Kit",
    text: "Find out which topics your new managers need most before choosing a workshop.",
    image: "https://cdn.magicpatterns.com/uploads/eemsQ3Hdx1ERfH5ucMP6Nr/manager_3.webp",
  },
  {
    title: "The Workshop Invitation & Reminder Pack",
    text: "Invite participants and remind them before the session without writing every message yourself.",
    image: "https://cdn.magicpatterns.com/uploads/nxkScNuM3Sxo35vHeMNasm/manager_4.webp",
  },
  {
    title: "The First-Time Facilitator Rescue Kit",
    text: "Support for leading your first sessions with more confidence and handling the moments that go off plan.",
    image: "https://cdn.magicpatterns.com/uploads/tULyeRFJtdrW92SuiG5DLt/manager_5.webp",
  },
];

export const problems = [
  {
    title: "“Can you put something together for Thursday?”",
    text: "New supervisors are starting and you've been asked to run a session — with days, not weeks, to prepare.",
  },
  {
    title: "The blank page eats your prep time.",
    text: "Deciding what to cover, what to cut, and how to fit it into an hour takes longer than running the session.",
  },
  {
    title: "Talking points aren't practice.",
    text: "Discussion questions alone don't give new managers a scenario to work through or a skill to rehearse.",
  },
  {
    title: "People leave without a next step.",
    text: "The session goes well, but nobody walks out with a concrete action for their next meeting or conversation.",
  },
];

export const audiences = [
  { title: "HR generalists", text: "Asked to support new managers and need a clear session structure." },
  { title: "Internal trainers", text: "Want practical plans and exercises to adapt to their workplace." },
  { title: "Team leaders", text: "Guiding new supervisors and want more than a discussion topic." },
];

export const workshopStructure = [
  { title: "Timed session agenda", text: "A 60-minute core plan with an optional 30-minute extension." },
  { title: "Facilitator scripts", text: "Openings, activity instructions, discussion prompts, and closing questions." },
  { title: "Workplace activities", text: "Fictional cases, paired exercises, and role practice." },
  { title: "Participant worksheets", text: "Printable pages for briefs, agendas, and conversation plans." },
  { title: "Questions & model answers", text: "Scenario-based checks with facilitator explanations." },
  { title: "Follow-up tools", text: "Action commitments, follow-up email, observation card, and review sheet." },
];

export const workshops = [
  { title: "From Teammate to Manager", text: "Prepare a role-transition message and clear boundaries with former peers." },
  { title: "Delegation That Works", text: "Create a task brief with ownership, standards, deadlines, and checkpoints." },
  { title: "Giving Useful Feedback", text: "Practice a fact-based opener and agree on a useful next step." },
  { title: "Effective 1-on-1 Meetings", text: "Build a focused meeting agenda and a simple action log." },
  { title: "Setting Clear Expectations", text: "Turn a vague request into a clear, observable agreement." },
  { title: "Difficult Conversations", text: "Prepare the conversation and respond respectfully to defensiveness." },
  { title: "Coaching Everyday Performance", text: "Use questions to help employees identify options and choose an action." },
  { title: "Managing Team Conflict", text: "Explore work constraints and create a practical coordination agreement." },
  { title: "Prioritization for Managers", text: "Make realistic trade-offs and explain decisions within available capacity." },
  { title: "Your First 30-Day Leadership Plan", text: "Choose two observable habits and create a feasible plan to practice them." },
];

export const samplePages = [
  { title: "The playbook cover", image: "https://cdn.magicpatterns.com/uploads/okB7eAfUearkZfuEvCVBzp/01_portada.png" },
  { title: "Choose the right workshop", image: "https://cdn.magicpatterns.com/uploads/wgs4esVVQiNEKcNFymddKq/02_10_talleres.png" },
  { title: "The ready-to-deliver system", image: "https://cdn.magicpatterns.com/uploads/ev4R46pyMAB4E2A726aasg/03_sistema_listo.png" },
  { title: "The 60-minute session map", image: "https://cdn.magicpatterns.com/uploads/2R5dDH2xBESJQMqad6yifc/04_mapa_sesion_60min.png" },
  { title: "Facilitator field card", image: "https://cdn.magicpatterns.com/uploads/6KWJe5YNdbmrG4yAUxXmYq/05_tarjeta_facilitador.png" },
];

export const offerIncludes = [
  "10 structured workshops",
  "60-min core sessions + extensions",
  "Facilitator scripts & scenarios",
  "Printable participant worksheets",
  "Checks with model answers",
  "Preparation & follow-up tools",
];

export const faqs = [
  {
    q: "What exactly is this product?",
    a: "A 40-page English-language facilitator playbook covering ten workshops for first-time managers. It is built around timed session plans, scripts, activities, printable worksheets, and practical follow-up tools.",
  },
  {
    q: "Are PowerPoint, Google Slides, or Canva decks included?",
    a: "No. This edition is the facilitator PDF. Editable presentation decks are not part of this offer. Sessions are designed to work with the guide, handouts, pens, and ordinary meeting materials.",
  },
  {
    q: "Do I need to be an experienced trainer?",
    a: "The guide is designed to support facilitators with limited experience. You still need to read the session, understand the scenario, and adapt it to your group before delivery.",
  },
  {
    q: "How long is each workshop?",
    a: "Each workshop has a 60-minute core agenda and an optional 30-minute extension. The extended session lasts 90 minutes.",
  },
  {
    q: "Can I use the workshops individually?",
    a: "Yes. Each workshop is designed to stand alone. You can also follow the sequence for a ten-session development program.",
  },
  {
    q: "Can I deliver sessions remotely?",
    a: "Each workshop includes a concise remote adaptation using standard video calls and breakout rooms. Prepare the participant prompts and check your meeting setup beforehand.",
  },
  {
    q: "Can I use this with paying clients or share it across my company?",
    a: "Commercial facilitation, redistribution, and multi-user permissions must follow the purchase license. Consultant and company-wide licenses are not included in this offer.",
  },
  {
    q: "Is this an accredited or compliance training program?",
    a: "No. It is educational manager-development material. It does not provide accredited certification, legal advice, compliance training, or an HR investigation process.",
  },
];

export const withoutPlaybook = [
  "Building an agenda from scratch for every request",
  "Writing activity instructions the night before",
  "Talking points with no practice built in",
  "Participants leave without a next step",
];

export const withPlaybook = [
  "A timed 60-minute plan ready to review",
  "Scripts for openings, activities, and debriefs",
  "A scenario and role practice for every topic",
  "A worksheet and action commitment to take back",
];
